import React from 'react';
import './ReviewsBar.css';

const ReviewsBar = () => {
  return (
    <section className="reviews-bar">
      <div className="reviews-bar__container">
        <h4 className="reviews-bar__title">As Reviewed On</h4>
        
        <div className="reviews-bar__logos-wrapper">
          {/* Trustpilot Logo */}
          <div className="reviews-bar__logo-item reviews-bar__logo-item--trustpilot">
            <img 
              src={`${process.env.PUBLIC_URL}/assets/images/Trustpilot-Logo-scaled.png`} 
              alt="Online Quran Classes Trusted By Trustpilot" 
              className="reviews-bar__img" 
            />
          </div>

          {/* Google Reviews Logo */}
          <div className="reviews-bar__logo-item reviews-bar__logo-item--google">
            <img 
              src={`${process.env.PUBLIC_URL}/assets/images/Google-Review-Logo-500x281-1.png`} 
              alt="Online Quran Classes Trusted By Google Reviews" 
              className="reviews-bar__img" 
            />
          </div>

          {/* Clutch Logo */}
          <div className="reviews-bar__logo-item">
            <img 
              src={`${process.env.PUBLIC_URL}/assets/images/535-5351764_clutch-co-logo-hd-png-download-removebg-preview-1.png`} 
              alt="Online Quran Classes Trusted By Clutch" 
              className="reviews-bar__img" 
            />
          </div>

          {/* REVIEWS.io Logo */}
          <div className="reviews-bar__logo-item">
            <img 
              src={`${process.env.PUBLIC_URL}/assets/images/66e00d77b400163fc0d831d0_4d3b0b51312903ee62e3ff7df64fc4af_reviewsio-logo.svg`} 
              alt="Online Quran Classes Trusted By Reviews.io" 
              className="reviews-bar__img" 
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReviewsBar;



